export enum DynamicFieldControlType {
    TextBox, MultiLine, RichText, Int, Matrix, YesNo, DatePicker,
    AreaDepartment, Separator, MultiUser, Double, BlockFinished, Category,
    TimeFromTo, UserList, AuditFindingData, AuditPlanMeasures, AuditDoMeasures,
    PlannedAudits, AuditProcesses, Documents, MeasureList, ColorPicker, Escalation, DataTemplatesMeasureList
}